module.exports = __webpack_public_path__ + "fonts/symantec_38x38.a2f9e8eecbe5bea6ba73c3a9eb87d65e.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/symantec_38x38.png
// module id = 766
// module chunks = 9